import graphql__d66703b47f866ae00693 from "./__generated__/OrganizationsMenuItemQuery.graphql.ts";
import graphql__a262a7c69663b09443d7 from "./__generated__/OrganizationsMenuItem_viewer.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'

import { OrganizationsMenuItem_viewer$key } from './__generated__/OrganizationsMenuItem_viewer.graphql'
import { OrganizationsMenuItemQuery } from './__generated__/OrganizationsMenuItemQuery.graphql'
import { OrganizationsRefetchQuery } from './__generated__/OrganizationsRefetchQuery.graphql'
import AppTenantMenuButton from './AppTenantMenuButton'

const query = graphql__d66703b47f866ae00693

const refetchableOrganizations = graphql__a262a7c69663b09443d7

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
  /** Callback for when the tenant is changed */
  onChangeTenant: (tenant: string | null) => void
}

export default function OrganizationsMenuItems({
  isOpen,
  onChangeTenant,
}: Props) {
  const { viewer } = useLazyLoadQuery<OrganizationsMenuItemQuery>(query, {})
  const [data, refetch] = useRefetchableFragment<
    OrganizationsRefetchQuery,
    OrganizationsMenuItem_viewer$key
  >(refetchableOrganizations, viewer)

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <>
      <AppTenantMenuButton
        onClick={() => onChangeTenant(null)}
        label="Personal"
      />

      {data?.me?.organizations?.map((org) => (
        <AppTenantMenuButton
          key={org?.id}
          label={org?.name}
          onClick={() => onChangeTenant(org?.slug)}
        />
      ))}
    </>
  )
}
